import { render, staticRenderFns } from "./CustomBottomBanner.vue?vue&type=template&id=7ffe66b2&scoped=true&"
import script from "./CustomBottomBanner.vue?vue&type=script&lang=js&"
export * from "./CustomBottomBanner.vue?vue&type=script&lang=js&"
import style0 from "./CustomBottomBanner.vue?vue&type=style&index=0&id=7ffe66b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffe66b2",
  null
  
)

export default component.exports